{
    "name": "bedok.siliconwat.org",
    "version": "6",
    "scripts": {
        "dev": "rm -rf .parcel-cache dist && parcel src/index.html --port 61995",
        "build": "PARCEL_COMMIT_TIMESTAMP=$(git log -1 --format=%ct) PARCEL_COMMIT_HASH=$(git rev-parse --short HEAD) parcel build src/index.html",
        "test": "echo \"Error: no test specified\" && exit 1",
        "serve": "firebase emulators:start --only auth,firestore,storage,functions,hosting,database",
        "fs": "firebase deploy --only firestore:rules",
        "indexes": "firebase deploy --only firestore:indexes",
        "storage": "firebase deploy --only storage",
        "db": "firebase deploy --only database",
        "ports": "sudo ./close-ports.sh"
    },
    "keywords": [
        "bedok"
    ],
    "author": "Thon Ly",
    "license": "Silicon Wat, Inc",
    "description": "Thank with HeartBank®",
    "devDependencies": {
        "@parcel/packager-raw-url": "^2.13.3",
        "@parcel/service-worker": "^2.13.3",
        "@parcel/transformer-jsonld": "^2.13.3",
        "@parcel/transformer-raw": "^2.13.3",
        "@parcel/transformer-webmanifest": "^2.13.3",
        "@types/bowser": "^1.0.31",
        "@types/google.maps": "^3.58.1",
        "@types/hammerjs": "^2.0.46",
        "@types/qrcode": "^1.5.5",
        "@types/serviceworker": "^0.0.111",
        "@types/sql.js": "^1.4.9",
        "@types/youtube": "^0.1.2",
        "autoprefixer": "^10.4.20",
        "buffer": "^6.0.3",
        "flowbite": "^3.0.0",
        "parcel": "^2.13.2",
        "postcss": "^8.4.49",
        "svgo": "^3.3.2",
        "tailwindcss": "^3.4.16",
        "typescript": "^5.7.2"
    },
    "dependencies": {
        "@googlemaps/js-api-loader": "^1.16.8",
        "@ungap/custom-elements": "^1.3.0",
        "bowser": "^2.12.1",
        "dexie": "^4.0.10",
        "firebase": "^11.5.0",
        "hammerjs": "^2.0.8",
        "lit-html": "^3.3.0",
        "process": "^0.11.10",
        "qrcode": "^1.5.4",
        "tesseract.js": "^6.0.0",
        "xxhash-wasm": "^1.1.0"
    }
}
